import { useNavigate } from "@tanstack/react-router";
import { useSnackbar } from "notistack";
import { TokensPayload } from "src/hooks/useAuth";
import { LoginResponseNetType } from "src/services/auth/NetTypes";
import { useRefreshToken as useRefreshTokenMutation } from "src/services/auth/refresh";
import { PATH_AUTH } from "src/utils/paths";

import useFetchInitialData from "./useFetchInitialData";

type Props = {
	signOut: () => void;
	signIn: (tokens: TokensPayload) => void;
};

export default function useRefreshToken({ signIn, signOut }: Props) {
	const { enqueueSnackbar } = useSnackbar();
	const { fetchInitialData } = useFetchInitialData();

	const navigate = useNavigate();

	const { mutate } = useRefreshTokenMutation(
		(data: LoginResponseNetType) => {
			fetchInitialData();
			signIn(data);
		},
		() => {
			enqueueSnackbar("La sesión ha expirado. Por favor vuelva a iniciar sesión.", {
				variant: "warning"
			});
			signOut();
			navigate({ to: PATH_AUTH.login, replace: true });
		}
	);

	return { mutate };
}
